import en_US from "./en-US.json";
import es_AR from "./es-AR.json";
import es_ES from "./es-ES.json";

export default {
  "en-US": {
    name: "English",
    translation: en_US,
  },
  "es-AR": {
    name: "Español de Argentina",
    translation: es_AR,
  },
  "es-ES": {
    name: "Español de España",
    translation: es_ES,
  },
};
